import {
  openBillingPaywall,
  setBillingEntitlement,
  setBillingPortalUrl,
} from "store/billing/billingSlice"
import type { StripeEntitlementResponse, StripeErrorResponse } from "store/billing/types"
import { store } from "store/store"

export const BILLING_PAYWALL_CODES = new Set([
  "billing_access_required",
  "billing_portal_required",
  "billing_trial_canceled",
])

export const syncBillingEntitlement = (entitlement: StripeEntitlementResponse | null) => {
  store.dispatch(setBillingEntitlement(entitlement))
}

export const syncBillingDenyState = (
  data: StripeErrorResponse,
  options?: {
    openPaywall?: boolean
  }
) => {
  if (data.entitlement) store.dispatch(setBillingEntitlement(data.entitlement))
  if (data.portalUrl) store.dispatch(setBillingPortalUrl(data.portalUrl))
  if (options?.openPaywall !== false) store.dispatch(openBillingPaywall())
}

export const isBillingPaywallError = (
  data: StripeErrorResponse | null
): data is StripeErrorResponse => Boolean(data?.code && BILLING_PAYWALL_CODES.has(data.code))
